module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "type-box"
  }, [_c('HeadSearch'), _vm._v(" "), _c('div', {
    staticClass: "type-select"
  }, [_c('div', {
    staticClass: "select-left"
  }, [_c('ul', _vm._l((_vm.cateTree), function(cate, index) {
    return _c('li', {
      class: _vm.selectCateId == cate.id ? 'select-left-active' : '',
      on: {
        "click": function($event) {
          return _vm.cateChange(index)
        }
      }
    }, [_vm._v(_vm._s(cate.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select-right"
  }, [_c('ul', _vm._l((_vm.subCateList), function(goods, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.goGoodsList(goods.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goods.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(goods.name))])])
  }), 0)])]), _vm._v(" "), _c('TabBar', {
    attrs: {
      "show-tab-bar": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62796e78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/GoodsCates.vue
// module id = 2433
// module chunks = 0